import React, { useState } from 'react';

import {
  InputGrid,
  useResponsiveParams,
  Text,
  useQuantaFormikContext,
  NotificationList,
} from 'quanta-ui';

export default function CustomerDetails({ fireQuote, role, PRD_CustomerTypeList, }) {
  const isQuoteReadOnly =
    [
      'quote saved',
      'underwriter approved',
      'underwriter rejected',
      'converted to proposal',
    ]?.includes(fireQuote?.status?.toString()?.toLowerCase()) ||
    (role?.toString()?.toLowerCase() !== 'underwriter' &&
      fireQuote?.status?.toString()?.toLowerCase() ===
        'pending uw approval');
  const getDomainData = (
    domainArr,
    searchText,
    searchType,
    returnType,
  ) => {
    return domainArr.find(
      (d) =>
        d[`${searchType}`]?.toString()?.trim()?.toLowerCase() ===
        searchText?.toString()?.trim()?.toLowerCase(),
    )
      ? domainArr.find(
          (d) =>
            d[`${searchType}`]?.toString()?.trim()?.toLowerCase() ===
            searchText?.toString()?.trim()?.toLowerCase(),
        )[`${returnType}`]
      : '';
  };

  const { values } = useQuantaFormikContext();
  const [alerts, setAlerts] = useState([]);

  const noOfColsMobile = 1,
    noOfColsDesktop = 3;

  let inputColSpans = useResponsiveParams({
    for_mobile: noOfColsMobile,
    for_desktop: noOfColsDesktop,
  });

  const screenType = useResponsiveParams({
    for_mobile: 'mobile',
    for_desktop: 'desktop',
  });
  let grid_data = [
    {
      type: 'select',
      label: (
        <>
          Product<Text severity="error"> *</Text>
        </>
      ),
      name: 'productKg',
      disabled: isQuoteReadOnly || fireQuote?.isQuoteCopied,
      data: [{
        label: 'Bharat Griha Raksha',
        value: 'Kotak Bharat Griha Raksha',
      },
      {
        label: 'Griha Raksha Plus',
        value: 'Kotak Griha Raksha Plus',
      },
      ],
    },
    {
      type: 'radiogroup',
      // label: (
      //   <>
      //     Policy for Individual Dwelling or Housing Society<Text severity="error"> *</Text>
      //   </>
      // ),
      colSpan: inputColSpans,
      name: 'customerDetails.customerType.code',
      disabledGlobal:
      isQuoteReadOnly,
      data: PRD_CustomerTypeList
        ? [
            ...PRD_CustomerTypeList.map((customerType) => {
              return {
                label: customerType.value ? customerType.value : '',
                value: customerType.code ? customerType.code : '',
              };
            }),
          ]
        : [],
      onRadioChange: (val, setFieldValue) => {
        setFieldValue(
          `customerDetails.customerType.value`,
          getDomainData(PRD_CustomerTypeList, val, 'code', 'value'),
        );
        if(val ===  'Organisation'){
            setFieldValue(
              `policyTypeDetails.tenure.value`,
              1,
            )
          }
      },
    },
    PRD_CustomerTypeList?.find(
      (type) =>
        type?.code?.toString()?.toLowerCase() ===
        values?.customerDetails?.customerType?.code
          ?.toString()
          ?.toLowerCase(),
    )
      ?.value?.toString()
      ?.toLowerCase() === 'housing society'
      ? {
          type: 'text',
          size: 'large',
          colSpan: inputColSpans,
          disabled:
          isQuoteReadOnly,
          label: (
            <>
              Insured Name<Text severity="error"> *</Text>
            </>
          ),
          name: 'customerDetails.orgInsuredName',
          onKeyDown: (evt) => {
            if (
              (evt?.target?.value?.toString()?.endsWith(' ') &&
                evt?.key === ' ') ||
              (evt?.target?.value?.toString()?.length === 0 &&
                evt?.key === ' ')
            ) {
              evt.preventDefault();
            }
          },
        }
      : null,
    PRD_CustomerTypeList?.find(
      (type) =>
        type?.code?.toString()?.toLowerCase() ===
        values?.customerDetails?.customerType?.code
          ?.toString()
          ?.toLowerCase(),
    )
      ?.value?.toString()
      ?.toLowerCase() === 'dwelling'
      ? {
          type: 'text',
          size: 'large',
          disabled:
          isQuoteReadOnly,
          label: (
            <>
              First Name<Text severity="error"> *</Text>
            </>
          ),
          name: 'customerDetails.firstName',
          
          onKeyDown: (evt) => {
            if (
              (evt?.target?.value?.toString()?.endsWith(' ') &&
                evt?.key === ' ') ||
              (evt?.target?.value?.toString()?.length === 0 &&
                evt?.key === ' ')
            ) {
              evt.preventDefault();
            }
          },
        }
      : null,
    PRD_CustomerTypeList?.find(
      (type) =>
        type?.code?.toString()?.toLowerCase() ===
        values?.customerDetails?.customerType?.code
          ?.toString()
          ?.toLowerCase(),
    )
      ?.value?.toString()
      ?.toLowerCase() === 'dwelling'
      ? {
          type: 'text',
          size: 'large',
          disabled:
          isQuoteReadOnly,
          label: (
            <>
              Middle Name<Text severity="error"> </Text>
            </>
          ),
          name: 'customerDetails.middleName',
          onKeyDown: (evt) => {
            if (
              (evt?.target?.value?.toString()?.endsWith(' ') &&
                evt?.key === ' ') ||
              (evt?.target?.value?.toString()?.length === 0 &&
                evt?.key === ' ')
            ) {
              evt.preventDefault();
            }
          },
        }
      : null,
    PRD_CustomerTypeList?.find(
      (type) =>
        type?.code?.toString()?.toLowerCase() ===
        values?.customerDetails?.customerType?.code
          ?.toString()
          ?.toLowerCase(),
    )
      ?.value?.toString()
      ?.toLowerCase() === 'dwelling'
      ? {
          type: 'text',
          size: 'large',
          disabled:
          isQuoteReadOnly,
          label: (
            <>
              Last Name<Text severity="error"> </Text>
            </>
          ),
          name: 'customerDetails.lastName',
          onKeyDown: (evt) => {
            if (
              (evt?.target?.value?.toString()?.endsWith(' ') &&
                evt?.key === ' ') ||
              (evt?.target?.value?.toString()?.length === 0 &&
                evt?.key === ' ')
            ) {
              evt.preventDefault();
            }
          },
        }
      : null,    
    //   {
    //   type: 'text',
    //   size: 'full',
    //   colSpan: inputColSpans,
    //   disabled: isQuoteReadOnly,
    //   label: (
    //     <>
    //       Business of Insured<Text severity="error"> *</Text>
    //     </>
    //   ),
    //   name: 'customerDetails.businessOfInsured',
    //   placeholder: 'Enter the nature of business',
    //   onKeyDown: (evt) => {
    //     if (
    //       (evt?.target?.value?.toString()?.endsWith(' ') &&
    //         evt?.key === ' ') ||
    //       (evt?.target?.value?.toString()?.length === 0 &&
    //         evt?.key === ' ')
    //     ) {
    //       evt.preventDefault();
    //     }
    //   },
    // },
  ].filter((d) => d);

  return (
    <>
      <InputGrid
        data={grid_data}
        repeat={inputColSpans}
        titleType="title"
        titleSeverity="info"
        size="large"
        gapX={10}
      />
      <div>
        <NotificationList {...{ items: alerts }} />
      </div>
    </>
  );
}
